"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inspect = void 0;
var dependencies_1 = require("./dependencies");
Object.defineProperty(exports, "inspect", { enumerable: true, get: function () { return dependencies_1.getDependencies; } });
//# sourceMappingURL=index.js.map